import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'

class NRTAvatar extends Component {

    render() {
        const {rounded, imgSource} = this.props

        return (
            <div style={{ background: '#dedede', backgroundImage: `url('${imgSource}')`, backgroundPosition: 'center' }} className={`avatar-container ${rounded ? 'rounded' : 'default'}`}>
            </div>
        )
    }
}


NRTAvatar.propTypes = {
    rounded: PropTypes.bool,
    imgSource: PropTypes.string,
}

NRTAvatar.defaultProps = {
    rounded: false,
    imgSource: require('./profile.svg')
}

export default NRTAvatar



// WEBPACK FOOTER //
// ./src/components/_common/Avatar/index.js